'use client'
import {useSearchParams} from "next/navigation";
import {SubmitButton} from "./submit-button";
import Link from "next/link";
import React, {useEffect} from "react";
import toast, {Toaster} from "react-hot-toast";
import PasswordInput from "./PasswordInput";

export default function LoginForm({signIn, redirectSignup}:any) {
    const searchParams = useSearchParams();

    useEffect(() => {
        const error = searchParams.get("error");
        if (error) {
            console.log(error)
            toast.error(error);
        }
    }, [searchParams]);

    return (
        <>
            <Toaster position="bottom-right" toastOptions={{duration: 7500}}/>
            <div className="flex flex-col gap-9">
                <div
                    className="rounded-sm bg-white dark:border-strokedark dark:bg-boxdark">
                    <form>
                        <div className="mb-4">
                            <label className="mb-2.5 block font-medium text-black dark:text-white">
                                Email
                            </label>
                            <div className="relative">
                                <input
                                    name='email'
                                    type="email"
                                    placeholder="Enter your email"
                                    className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                                />

                                <span className="absolute right-4 top-4">
                      <svg
                          className="fill-current"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.5">
                          <path
                              d="M19.2516 3.30005H2.75156C1.58281 3.30005 0.585938 4.26255 0.585938 5.46567V16.6032C0.585938 17.7719 1.54844 18.7688 2.75156 18.7688H19.2516C20.4203 18.7688 21.4172 17.8063 21.4172 16.6032V5.4313C21.4172 4.26255 20.4203 3.30005 19.2516 3.30005ZM19.2516 4.84692C19.2859 4.84692 19.3203 4.84692 19.3547 4.84692L11.0016 10.2094L2.64844 4.84692C2.68281 4.84692 2.71719 4.84692 2.75156 4.84692H19.2516ZM19.2516 17.1532H2.75156C2.40781 17.1532 2.13281 16.8782 2.13281 16.5344V6.35942L10.1766 11.5157C10.4172 11.6875 10.6922 11.7563 10.9672 11.7563C11.2422 11.7563 11.5172 11.6875 11.7578 11.5157L19.8016 6.35942V16.5688C19.8703 16.9125 19.5953 17.1532 19.2516 17.1532Z"
                              fill=""
                          />
                        </g>
                      </svg>
                    </span>
                            </div>
                        </div>


                        <PasswordInput name={'password'} label={'Password'}/>

                        <div className="mb-5.5 mt-5 flex items-center justify-between">
                      {/*      <label htmlFor="formCheckbox" className="flex cursor-pointer">*/}
                      {/*          <div className="relative pt-0.5">*/}
                      {/*              <input*/}
                      {/*                  type="checkbox"*/}
                      {/*                  id="formCheckbox"*/}
                      {/*                  className="taskCheckbox sr-only"*/}
                      {/*              />*/}
                      {/*              <div*/}
                      {/*                  className="box mr-3 flex h-5 w-5 items-center justify-center rounded border border-stroke dark:border-strokedark">*/}
                      {/*<span className="text-white opacity-0">*/}
                      {/*  <svg*/}
                      {/*      className="fill-current"*/}
                      {/*      width="10"*/}
                      {/*      height="7"*/}
                      {/*      viewBox="0 0 10 7"*/}
                      {/*      fill="none"*/}
                      {/*      xmlns="http://www.w3.org/2000/svg"*/}
                      {/*  >*/}
                      {/*    <path*/}
                      {/*        fillRule="evenodd"*/}
                      {/*        clipRule="evenodd"*/}
                      {/*        d="M9.70685 0.292804C9.89455 0.480344 10 0.734667 10 0.999847C10 1.26503 9.89455 1.51935 9.70685 1.70689L4.70059 6.7072C4.51283 6.89468 4.2582 7 3.9927 7C3.72721 7 3.47258 6.89468 3.28482 6.7072L0.281063 3.70701C0.0986771 3.5184 -0.00224342 3.26578 3.785e-05 3.00357C0.00231912 2.74136 0.10762 2.49053 0.29326 2.30511C0.4789 2.11969 0.730026 2.01451 0.992551 2.01224C1.25508 2.00996 1.50799 2.11076 1.69683 2.29293L3.9927 4.58607L8.29108 0.292804C8.47884 0.105322 8.73347 0 8.99896 0C9.26446 0 9.51908 0.105322 9.70685 0.292804Z"*/}
                      {/*        fill=""*/}
                      {/*    />*/}
                      {/*  </svg>*/}
                      {/*</span>*/}
                      {/*              </div>*/}
                      {/*          </div>*/}
                      {/*          <p>Remember me</p>*/}
                      {/*      </label>*/}

                            <Link href="/reset-password" className="text-sm text-primary hover:underline">
                                Forgot password?
                            </Link>
                        </div>

                        <SubmitButton
                            formAction={signIn}
                            className="text-foreground mb-2 flex w-full justify-center rounded bg-primary p-3 px-4 py-2 font-medium text-gray hover:bg-opacity-90"
                            pendingText="Signing In..."
                        >
                            Sign In
                        </SubmitButton>
                        <SubmitButton
                            formAction={redirectSignup}
                            className="border-foreground/70 text-foreground mb-2 flex w-full justify-center rounded border p-3 px-4 py-2 font-medium text-blue-700 hover:bg-opacity-90"
                            pendingText="Redirecting..."
                        >
                            Sign Up
                        </SubmitButton>
                        {/*<hr className="my-12 h-0.5 border-t-0 bg-neutral-100 dark:bg-white/10"/>*/}
                        {/*<SubmitButton*/}
                        {/*    formAction={signInWithGoogle}*/}
                        {/*    className="border-foreground/70 text-foreground mb-2 flex w-full justify-center rounded border p-3 px-4 py-2 font-medium text-blue-700 hover:bg-opacity-90"*/}
                        {/*    pendingText="Redirecting..."*/}
                        {/*>*/}
                        {/*        <span>*/}
                        {/*          <svg*/}
                        {/*              width="20"*/}
                        {/*              height="20"*/}
                        {/*              viewBox="0 0 20 20"*/}
                        {/*              fill="none"*/}
                        {/*              xmlns="http://www.w3.org/2000/svg"*/}
                        {/*          >*/}
                        {/*            <g clipPath="url(#clip0_191_13499)">*/}
                        {/*              <path*/}
                        {/*                  d="M19.999 10.2217C20.0111 9.53428 19.9387 8.84788 19.7834 8.17737H10.2031V11.8884H15.8266C15.7201 12.5391 15.4804 13.162 15.1219 13.7195C14.7634 14.2771 14.2935 14.7578 13.7405 15.1328L13.7209 15.2571L16.7502 17.5568L16.96 17.5774C18.8873 15.8329 19.9986 13.2661 19.9986 10.2217"*/}
                        {/*                  fill="#4285F4"*/}
                        {/*              />*/}
                        {/*              <path*/}
                        {/*                  d="M10.2055 19.9999C12.9605 19.9999 15.2734 19.111 16.9629 17.5777L13.7429 15.1331C12.8813 15.7221 11.7248 16.1333 10.2055 16.1333C8.91513 16.1259 7.65991 15.7205 6.61791 14.9745C5.57592 14.2286 4.80007 13.1801 4.40044 11.9777L4.28085 11.9877L1.13101 14.3765L1.08984 14.4887C1.93817 16.1456 3.24007 17.5386 4.84997 18.5118C6.45987 19.4851 8.31429 20.0004 10.2059 19.9999"*/}
                        {/*                  fill="#34A853"*/}
                        {/*              />*/}
                        {/*              <path*/}
                        {/*                  d="M4.39899 11.9777C4.1758 11.3411 4.06063 10.673 4.05807 9.99996C4.06218 9.32799 4.1731 8.66075 4.38684 8.02225L4.38115 7.88968L1.19269 5.4624L1.0884 5.51101C0.372763 6.90343 0 8.4408 0 9.99987C0 11.5589 0.372763 13.0963 1.0884 14.4887L4.39899 11.9777Z"*/}
                        {/*                  fill="#FBBC05"*/}
                        {/*              />*/}
                        {/*              <path*/}
                        {/*                  d="M10.2059 3.86663C11.668 3.84438 13.0822 4.37803 14.1515 5.35558L17.0313 2.59996C15.1843 0.901848 12.7383 -0.0298855 10.2059 -3.6784e-05C8.31431 -0.000477834 6.4599 0.514732 4.85001 1.48798C3.24011 2.46124 1.9382 3.85416 1.08984 5.51101L4.38946 8.02225C4.79303 6.82005 5.57145 5.77231 6.61498 5.02675C7.65851 4.28118 8.9145 3.87541 10.2059 3.86663Z"*/}
                        {/*                  fill="#EB4335"*/}
                        {/*              />*/}
                        {/*            </g>*/}
                        {/*            <defs>*/}
                        {/*              <clipPath id="clip0_191_13499">*/}
                        {/*                <rect width="20" height="20" fill="white"/>*/}
                        {/*              </clipPath>*/}
                        {/*            </defs>*/}
                        {/*          </svg>*/}
                        {/*        </span>*/}
                        {/*    Continue with Google*/}
                        {/*</SubmitButton>*/}
                    </form>
                </div>
            </div>
        </>
    );
}
